import FlashLib from "flashlib";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import RelaxModel from "Base/model/RelaxModel";
import MoneyFormat from "Base/MoneyFormat";
import GameModel from "../../../icarusWilds/src/model/GameModel";
import EntryPoint from "Engine/EntryPoint";

export default class RealityCheckContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
        this.addListeners();
        this.addActions();
        this.hide();
    }

    init() {
        this.continueButton = this.getChildByName('continueButton');
        this.historyButton = this.getChildByName('historyButton');
        this.exitButton = this.getChildByName('exitButton');

        this.playingTimeText = this.getChildByName('label_reality_check_body');
        this.losesText = this.getChildByName('label_reality_check_losses');
        this.winningsText = this.getChildByName('label_reality_check_winnings');

        this.continueButton.enabled = true;
        this.historyButton.enabled = true;
        this.exitButton.enabled = true;
    }

    addListeners() {
        GlobalDispatcher.add('stateEnd:stopRollingState', this.onShow, this);
    }

    addActions() {
        this.continueButton.actions = {
            click: {
                callback: this.onContinueClick, context: this,
            },
            touchend: {
                callback: this.onContinueClick, context: this,
            }
        };
        this.historyButton.actions = {
            click: {
                callback: this.onHistoryClick, context: this,
            },
            touchend: {
                callback: this.onHistoryClick, context: this,
            }
        };
        this.exitButton.actions = {
            click: {
                callback: this.onExitClick, context: this,
            },
            touchend: {
                callback: this.onExitClick, context: this,
            }
        };
    }

    onContinueClick() {
        GlobalDispatcher.dispatch('realityCheck:continue');
        this.hide();
    }

    onHistoryClick() {
        RelaxModel.accountHistory();
    }

    onExitClick() {
        RelaxModel.exitGame();
    }

    setTexts() {
        this.playingTimeText.setTextParams(this.calculateTime());
        this.losesText.setTextParams(MoneyFormat.format(RelaxModel.realityCheck.betSum, false), MoneyFormat.gameCurrency);
        this.winningsText.setTextParams(MoneyFormat.format(RelaxModel.realityCheck.winSum, false), MoneyFormat.gameCurrency);
    }

    calculateTime() {
        let time = RelaxModel.realityCheck.totalSessionMinutes;
        let hours = Math.floor(time / 60);
        let minutes = time % 60;
        hours = hours > 10 ? /*'0' +*/ hours : hours;
        minutes = minutes > 10 ? /*'0' +*/ minutes : minutes;
        return hours + ':' + minutes;
    }

    onShow(event) {
        if (RelaxModel.realityCheck && RelaxModel.realityCheck.status === 'error' && GameModel.totalWin === 0) {
            this.show();
        }
    }

    show() {
        GlobalDispatcher.dispatch('overlay:show');
        this.setTexts();
        this.visible = true;
    }

    hide() {
        GlobalDispatcher.dispatch('overlay:hide');
        this.visible = false;
    }
}
